export const errorSeverities = {
	unexpectedError: 'UnexpectedError',
	warning: 'Warning',
	validationError: 'ValidationError',
	applicationError: 'ApplicationError',
} as const;
